import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { AppContext } from '../../contexts/AppContext'
import useUser from '../../contexts/hooks/useUser'
import { useContract } from '../../hooks/useContract'
import { trpc } from '../../modules/trpc'

const MoveOutCTA = () => {
	const { toggleMenu, menuOpen } = useContext(AppContext)

	const history = useHistory()

	const { user } = useUser()

	const { t } = useTranslation('pages_contact')
	const [state, setState] = useState({ isLoading: true, isOwner: false })

	const { contractData: contractInfo } = useContract()

	const { data: synerallUser } = trpc.synerall.userByPid.useQuery(
		{ personalId: user?.personalId ?? '' },
		{ enabled: user?.personalId !== undefined }
	)

	useEffect(() => {
		if (contractInfo && synerallUser) {
			setState({ isLoading: false, isOwner: synerallUser.Id === contractInfo?.CustomerID })
		}
	}, [contractInfo, synerallUser])

	const onOpenMoveout = () => {
		if (menuOpen) {
			toggleMenu()
		}

		history.push('/contact/move-out')
	}

	return (
		<>
			{state.isOwner && (
				<div
					className='text-center p-[0.6rem] rounded-[0.5rem] hover flex items-center justify-center gap-2 tracking-wide bg-brand-primary-100-light text-white dark:bg-brand-primary-100-dark'
					onClick={onOpenMoveout}
				>
					{t('moveout.cta')}
				</div>
			)}
		</>
	)
}

export default MoveOutCTA
